module.exports = __webpack_public_path__ + "static/fiji3-1024x850-b1314f6001d6f58ce74190296118ff0e.png";